import React, { useCallback } from "react";
import classNames from "classnames";
import { useMsal } from "@azure/msal-react";
import {
  Avatar,
  Dropdown,
  DropdownItem,
  HeaderWidgets,
  ToggleButton,
} from "@flixbus/honeycomb-react";
import {
  Icon,
  IconProfileSolid,
  IconSun,
  IconNight,
} from "@flixbus/honeycomb-icons-react";
import { useThemeContext } from "@/providers/ThemeProvider";
import { EnvBadge, envBadgeWidgetClass } from "@/pages/Login/EnvBadge";

type LoginWidgetProps = {
  extraClasses?: string;
};

export const LoginWidget: React.FC<LoginWidgetProps> = ({ extraClasses }) => {
  const { instance, accounts } = useMsal();
  const account = instance.getActiveAccount() ?? accounts[0] ?? null;

  const { isDark, toggleDark } = useThemeContext();
  const widgetClasses =
    classNames(envBadgeWidgetClass, extraClasses) || undefined;

  const handleToggleTheme = useCallback(() => {
    toggleDark();
  }, [toggleDark]);

  return (
    <HeaderWidgets aria-label="Login widget" extraClasses={widgetClasses}>
      <EnvBadge />
      {account && (
        <nav aria-label="User menu">
          <Dropdown
            xPosition="left"
            links={[
              <DropdownItem
                key="theme"
                Elem="button"
                InlineIcon={isDark ? IconSun : IconNight}
                onClick={handleToggleTheme}
              >
                {isDark ? "Light theme" : "Dark theme"}
              </DropdownItem>,
            ]}
          >
            <ToggleButton appearance="link">
              <Avatar>
                <Icon
                  InlineIcon={IconProfileSolid}
                  size="cover"
                  fillCanvas
                  aria-hidden="true"
                />
              </Avatar>
              {account.name || ""}
            </ToggleButton>
          </Dropdown>
        </nav>
      )}
    </HeaderWidgets>
  );
};
